export default __webpack_public_path__ + "static/leaves-8689a124978fe7b9fe89b95df420c065.gif";